// extracted by mini-css-extract-plugin
module.exports = {"container":"TopBar_container__19yV6","contentLogo":"TopBar_contentLogo__1oZBj","nomeUsuario":"TopBar_nomeUsuario__1bVoY","contentCollapse":"TopBar_contentCollapse__1F7JN"};